import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, MENU_ITEMS } from '../data/company';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-12 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-slate-800">
          
          {/* Col 1: Company Profile */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="bg-white p-1.5 rounded-lg">
                <img
                  src={COMPANY_INFO.logoUrl}
                  alt="OP Rengøringsservice Logo"
                  className="h-9 w-auto object-contain"
                />
              </div>
            </div>

            <p className="text-slate-400 text-sm leading-relaxed">
              Tilbyder solide serviceydelser inden for vinduespudsning, rengøring, haveservice samt snerydning til både private og erhvervskunder i Nibe og omegn.
            </p>

            <div className="pt-2">
              <a
                href={COMPANY_INFO.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-slate-300 hover:text-sky-400 transition-colors text-sm font-medium bg-slate-800 hover:bg-slate-750 px-3 py-1.5 rounded-lg border border-slate-700"
              >
                <i className="fa-brands fa-facebook text-sky-400" aria-hidden="true" />
                <span>Følg os på Facebook</span>
              </a>
            </div>
          </div>

          {/* Col 2: Primary Navigation */}
          <div>
            <h4 className="font-bold text-white text-base mb-4 tracking-wide uppercase text-xs text-slate-400">
              Sider
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-sky-400 transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true" />
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="hover:text-sky-400 transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true" />
                  <span>Rengøringsydelser</span>
                </Link>
              </li>
              <li>
                <Link to="/hvem-er-vi" className="hover:text-sky-400 transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true" />
                  <span>Hvem er vi?</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-sky-400 transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true" />
                  <span>Kontakt</span>
                </Link>
              </li>
              <li>
                <Link to="/category-projekt" className="hover:text-sky-400 transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true" />
                  <span>Projekt & Referencer</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Services */}
          <div>
            <h4 className="font-bold text-white text-base mb-4 tracking-wide uppercase text-xs text-slate-400">
              Vores Ydelser
            </h4>
            <ul className="space-y-2 text-sm">
              {MENU_ITEMS[1].children.map((sub) => (
                <li key={sub.href}>
                  <Link to={sub.href} className="hover:text-sky-400 transition-colors inline-flex items-center gap-2 text-slate-300">
                    <i className="fa-solid fa-check text-[10px] text-sky-400" aria-hidden="true" />
                    <span>{sub.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact Info & Tilbud CTA */}
          <div className="space-y-4">
            <h4 className="font-bold text-white text-base tracking-wide uppercase text-xs text-slate-400">
              Kontakt Os
            </h4>

            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-sky-400 mt-1" aria-hidden="true" />
                <span className="text-slate-300">{COMPANY_INFO.address}</span>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-sky-400" aria-hidden="true" />
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="text-white hover:text-sky-400 font-bold transition-colors whitespace-nowrap-custom"
                >
                  {COMPANY_INFO.phone}
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-sky-400" aria-hidden="true" />
                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  className="text-slate-300 hover:text-white transition-colors whitespace-nowrap-custom"
                >
                  {COMPANY_INFO.email}
                </a>
              </div>
            </div>

            <div className="pt-2">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center gap-2 w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-2.5 px-4 rounded-lg shadow transition-colors text-sm"
              >
                <span>Få et uforpligtende tilbud</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <div>
            © {currentYear} {COMPANY_INFO.name}. Alle rettigheder forbeholdes.
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://www.iubenda.com/privacy-policy/87244873"
              className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors"
              title="Privatlivspolitik "
            >
              Privatlivspolitik
            </a>
            <span className="text-slate-600">·</span>
            <a
              href="https://www.iubenda.com/privacy-policy/87244873/cookie-policy"
              className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors"
              title="Cookiepolitik "
            >
              Cookiepolitik
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
